import React, { ReactElement } from 'react';

import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { RiArrowDropUpLine } from 'react-icons/ri';

const AccordionHeader = (props) => {
  return (
    <Box>
      <Flex
        justifyContent="space-between"
        px={2}
        py={2}
        fontWeight={600}
        color="orange.primary"
      >
        <Text fontSize={14}>{props.name}</Text>
        <Link>
          <RiArrowDropUpLine fontSize={30} color="orange" />
        </Link>
      </Flex>
    </Box>
  );
};

export default AccordionHeader;
